var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconToggleVehicleOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 6,
    viewBox: "0 0 13 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6L6.5 -5.68248e-07L0 6L13 6Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggleVehicleOff);
export default __webpack_public_path__ + "static/media/icon_toggle_vehicle_off.3ea450c1a942bcd1c59d39feafaefd81.svg";
export { ForwardRef as ReactComponent };